(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search-box"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  document.querySelectorAll('[data-pcshop-search-categories][open]').forEach(function(picker) {
    if (!picker.contains(event.target)) picker.open = false;
  });
});
document.addEventListener('keydown', function(event) {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[data-pcshop-search-categories][open]').forEach(function(picker) { picker.open = false; });
});
  } catch(e) { console.error(e); }
})();

})();
